import { defineComponent as _defineComponent } from 'vue'
import '@paypal/paypal-js';
import { computed, watch } from 'vue';
import { getPayPalSDK } from 'JS/services/PayPalService';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaypalPayLaterMessage',
  props: {
	hidePrice: { type: Boolean, required: false, default: false },
	hideWhenIneligible: { type: Boolean, required: false, default: false },
	price: { type: Number, required: true },
},
  setup(__props) {

const props = __props



const hideMessage = computed(() => props.hideWhenIneligible && (props.price == null || props.price < 30 || props.price > 10000));
const priceToDisplay = computed(() => props.hidePrice ? null : props.price);

watch(hideMessage, hide => {
	if (!hide) {
		getPayPalSDK();
	}
}, {
	immediate: true,
});


return { __sfc: true,props, hideMessage, priceToDisplay }
}

})